import firstBy from 'thenby';
import naturalCompare from 'natural-compare-lite';

export default function sortByNaturalString({ key, order }) {
  return firstBy((a, b) => {
    const sortResult = naturalCompare(
      String(a[key]).toLowerCase(),
      String(b[key]).toLowerCase(),
    );

    if (order === 'asc') {
      return sortResult;
    }

    return -sortResult;
  });
}
